import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const routes: VueRoute[] = [
  {
    path: "/events/:id/contacts",
    action: async ({ pathname }) => {
      const c = await import("@/modules/contacts/views/contactsLinked.vue");
      return h(c.default, { id: pathname.groups.id, type: "event" });
    },
  },
  {
    path: "/events/:slug?",
    action: async ({ pathname }) => {
      const id = pathname.groups.slug;
      const c = id
        ? await import("./views/eventEdit.vue")
        : await import("./views/events.vue");
      return h(c.default, { id });
    },
  },
];

export default routes;
